import React, { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Cookies from 'js-cookie'
import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";
import { useCookies } from 'react-cookie';

import Autorize from '../../../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Lst_officers({secteur,clubid,MyAnnee}) {

    const [officerlist, setofficerlist] = useState("");   
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false"); 
  
 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    
    useEffect(() => { 
        console.log("***********************************************");
            //, { headers: { Authorization: "Bearer "+ cookies }}
                    
            if(autorize)
            {            
                if(MyAnnee != "")
                {
                   // console.log(process.env.REACT_APP_API + '/rapports/getrepportofficer/secteur/'+ secteur +'/club/'+ clubid + "/" + MyAnnee );
                    MyAxios.get(process.env.REACT_APP_API + '/rapports/getrepportofficer/secteur/'+ secteur +'/club/'+ clubid + "/" + MyAnnee ) //axios.defaults.withCredentials = true
                    .then((res) => {      
                        setErrorAxios(false);
                        //console.log(res);
                        setofficerlist(res.data);
                    
                    })
                    .catch((error) => {
                        console.log(error)  
                    ///  if(error.status)  
                    if(error.response.status === 401)// pas autorisé
                        setErrorAxios(true);  

                    });
                }
            }
    },[MyAnnee,autorize]);
   

    const navigate = useNavigate();       
    const dispatch = useDispatch();

        
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };          
        
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
        return (
                <div>
                    <Autorize  axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                    <Box sx={{display: 'flex', flexDirection: 'row' }} >
                   
                        {Object.entries(officerlist).map(([key, value]) => (
        
                            <Card sx={{ maxWidth: 345 , margin:'10px' }} key={value.club_officersID}>                        
                                <CardContent>
                                    <Typography gutterBottom variant="h7" component="div" align="left">
                                    {value.Title } 
                                    </Typography>

                                    <Typography variant="body2" color="text.secondary" align="left">
                                        {value.First_Name  }  {value.Last_Name  }<br />                                     
                                        { value.Address  }  {value.City  }<br /> 
                                
                                        {value.E_Mail_Address  }  <br /> 
                                        {value.Home_Phone_Number  }<br /> 
                                    
                                        À partir de: {value.Effective_Date  }<br /> 
                                        Se termine le : { value.Date_Deleted  }  
                                    </Typography>
                                </CardContent>
                            
                            </Card>
                            
        
                            
                        ))}
   
                    </Box>
                   
                </div>
       
        );
   
};

export default Lst_officers;